import React, { FC } from 'react';
import { iconSize } from '../../../../constants/icon.constants';
import { getImageField } from '../../../../utils/getImageFields';
import { getThumbnailProps } from '../../../../utils/youtube.utils';
import Picture from '../../../@shared/picture';
import { TEditorialImageProps } from '../../../@shared/picture/types/editorialImage.types';
import VideoPlayer from '../../../@shared/videoPlayer';
import { TLatestNewsMedia } from '../../types/latestNews.types';

const Media: FC<TLatestNewsMedia> = (props) => {
  const { desktopImage, mobileImage, defaultImage, useVideo, videoUrl, isDesktop } = props;
  if (useVideo && videoUrl) {
    const { thumbnailImgSrc } = getThumbnailProps(videoUrl);
    const desktopImageOrThumbnail = getImageField(desktopImage, thumbnailImgSrc || '', useVideo);
    const mobileImageOrThumbnail = getImageField(mobileImage, thumbnailImgSrc || '', useVideo);
    return (
      <div className="latest-news-card__media-wrapper latest-news-card__media-wrapper--thumbnail">
        <VideoPlayer
          link={videoUrl}
          autoPlay={true}
          showThumbnail={true}
          editorialImageProps={{
            desktopImage: desktopImageOrThumbnail,
            mobileImage: mobileImageOrThumbnail,
            isEditable: true,
            alt: `${isDesktop ? desktopImageOrThumbnail?.value?.alt : mobileImageOrThumbnail?.value?.alt}`,
          }}
          extraClassName={'latest-news-card__media-wrapper--video'}
          iconColor={'white'}
          desktopPlayIconSize={iconSize.md}
          mobilePlayIconSize={iconSize.dsk}
        />
      </div>
    );
  }

  const shouldShowDefaultImage = !desktopImage?.value?.src && !mobileImage?.value?.src;
  const editorialProps: TEditorialImageProps = {
    mobileImage: mobileImage,
    desktopImage: desktopImage,
    mobileTransformation: 'Size1000',
    desktopTransformation: 'Size1000',
    cssClassPictureEl: 'latest-news-card__image',
    alt: `${isDesktop ? desktopImage?.value?.alt : mobileImage?.value?.alt}`,
  };
  if (shouldShowDefaultImage && defaultImage) {
    editorialProps['mobileImage'] = undefined;
    editorialProps['desktopImage'] = defaultImage;
  }
  return (
    <div className="latest-news-card__media-wrapper">
      <Picture editorialImageProps={editorialProps} />
    </div>
  );
};

export default Media;
